var map = {
	"./covid-hits-home-1.jpg": "42ef",
	"./covid-hits-home-10.jpg": "b474",
	"./covid-hits-home-11.jpg": "522e",
	"./covid-hits-home-12.jpg": "ff89",
	"./covid-hits-home-15.jpg": "d0e0",
	"./covid-hits-home-16.jpg": "e50f",
	"./covid-hits-home-17.jpg": "c7c6",
	"./covid-hits-home-2.jpg": "876f",
	"./covid-hits-home-3.jpg": "d74f",
	"./covid-hits-home-4.jpg": "20f7",
	"./covid-hits-home-5.jpg": "abf4",
	"./covid-hits-home-6.jpg": "4436",
	"./covid-hits-home-7.jpg": "6d41",
	"./covid-hits-home-8.jpg": "7f41",
	"./covid-hits-home-9.jpg": "7404",
	"./grid/covid-hits-home-13.jpg": "55fe",
	"./grid/covid-hits-home-14.jpg": "b0f8",
	"./intro/covid-hits-home-scrollyimage1-desktop.jpg": "935a",
	"./intro/covid-hits-home-scrollyimage1.jpg": "080d",
	"./intro/covid-hits-home-scrollyimage2-desktop.jpg": "d36c",
	"./intro/covid-hits-home-scrollyimage2.jpg": "8b56",
	"./intro/covid-hits-home-scrollyimage3-desktop.jpg": "b120",
	"./intro/covid-hits-home-scrollyimage3.jpg": "025b",
	"./template/image-background-header-desktop.jpg": "5c5b",
	"./template/image-background-header.jpg": "32e0",
	"./template/sample-image-desktop.png": "3100",
	"./template/sample-image.png": "da96",
	"./template/sample-logo.svg": "2bfb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";